import { render, staticRenderFns } from "./laowuDetail.vue?vue&type=template&id=6de74392&scoped=true&"
import script from "./laowuDetail.vue?vue&type=script&lang=js&"
export * from "./laowuDetail.vue?vue&type=script&lang=js&"
import style0 from "./laowuDetail.vue?vue&type=style&index=0&id=6de74392&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de74392",
  null
  
)

export default component.exports